import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

const Cancel: React.FC = () => {
  const { language } = useLanguage();

  const content = {
    en: {
      title: "Payment Cancelled",
      description: "Your payment was cancelled. If you have any questions, please contact us.",
      backToHome: "Back to Home"
    },
    da: {
      title: "Betaling Annulleret",
      description: "Din betaling blev annulleret. Hvis du har spørgsmål, er du velkommen til at kontakte os.",
      backToHome: "Tilbage til Forsiden"
    }
  };

  return (
    <div className="min-h-screen bg-[#1A1A1A] flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white/10 backdrop-blur-md rounded-2xl p-8 text-center relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-[#A68B7C]/20 to-transparent opacity-50" />
        
        <div className="relative z-10">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>

          <h1 
            className="text-3xl font-serif font-bold mb-4 text-white"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            {content[language as keyof typeof content].title}
          </h1>
          
          <p className="text-gray-300 mb-8">
            {content[language as keyof typeof content].description}
          </p>

          <Link
            to="/"
            className="inline-block px-6 py-3 bg-[#A68B7C] text-white rounded-lg hover:bg-[#95796A] transition-all duration-300"
          >
            {content[language as keyof typeof content].backToHome}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Cancel;